import React from "react";
import { IoSearch } from "react-icons/io5";
import { Link } from "react-router-dom";

const SearchItem = () => {
  return (
    <li className="search">
      <Link to="/search" className="red-color" aria-label="Search">
        <IoSearch style={{ fontSize: "1.8rem" }} /> {/* Adjust size as needed */}
      </Link>
    </li>
  );
};

export default SearchItem;
